export enum PayLinkProcardpayRoute {
  PayLinkProcardpay = '/pay-link/procardpay',
}
